
<template>
    <v-container class="pa-5" fluid>
        <page-title>Kontrola kodów EAN</page-title>
        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="12" sm="4" md="4" lg="3">
                            <v-text-field
                                v-model="filters.orderNumber"
                                label="Numer zamówienia..."
                                single-line
                                clearable
                                hide-details
                                solo
                                @keyup.enter="changeFilter"
                                @click:append="changeFilter"
                                @click:clear="clearFilter('orderNumber')"
                            />
                        </v-col>
                    </v-row>
                    <v-row justify="end" no-gutters>
                        <v-col cols="auto" class="mt-4">
                            <v-btn
                                text
                                x-small
                                data-sentry-label="Generuj raport"
                                :disabled="generateReportLoading"
                                @click="generateCodeCompliancesListReport"
                            >
                                <v-icon
                                    v-if="!generateReportLoading"
                                    small
                                    color="green"
                                >
                                    mdi-file-excel
                                </v-icon>
                                <v-progress-circular
                                    v-else
                                    indeterminate
                                    color="primary"
                                    class="mr-1"
                                    size="12"
                                    width="2"
                                />
                                Generuj raport
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="codeCompliancesList"
                        :loading="compliancesListLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :mobile-breakpoint="0"
                        name="complianceData"
                        @pagination="updatePagination"
                    >
                        <template #item="{item}">
                            <tr>
                                <td>
                                    {{ formatDate(item.createdAt, false) }}
                                </td>
                                <td class="text-center">
                                    {{ item.createdBy }}
                                </td>
                                <td class="text-center">
                                    {{ item.orderNumber }}
                                </td>
                                <td class="text-center">
                                    {{ item.referentialPattern }}
                                </td>
                                <td class="text-center">
                                    {{ item.compliantCodesSum }}
                                </td>
                                <td class="text-center">
                                    {{ item.nonCompliantCodesSum }}
                                </td>
                            </tr>
                        </template>

                        <template slot="no-results" :value="true">
                            <p class="text-center">
                                Brak danych
                            </p>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import dateFormatter from '@/mixins/dateFormatter'
import customFilters from '@/mixins/customFilters'
import { errorHandler } from '@/utils/errorHandler'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'

export default {
    name: 'CodeCompliancesList',
    components: {
        PageTitle,
    },
    mixins: [
        filters,
        customFilters,
        pagination,
        dateFormatter
    ],
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('reports/clearCodeCompliancesFilters')
        next()
    },
    data() {
        return {
            compliancesListLoading: false,
            generateReportLoading: false,
            headers: [
                {
                    'text': 'Data',
                    'value': 'createdAt',
                    'sortable': false,
                    'align': 'center,'
                },
                {
                    'text': 'Operator',
                    'value': 'createdBy',
                    'sortable': false,
                    'align': 'center',
                },
                {
                    'text': 'Numer zamówienia',
                    'value': 'orderNumber',
                    'sortable': false,
                    'align': 'center',
                },
                {
                    'text': 'Kod',
                    'value': 'referentialPattern',
                    'sortable': false,
                    'align': 'center',
                },
                {
                    'text': 'Zgodność kodu',
                    'value': 'compliantCodesSum',
                    'sortable': false,
                    'align': 'center',
                },
                {
                    'text': 'Niezgodność kodu',
                    'value': 'nonCompliantCodesSum',
                    'sortable': false,
                    'align': 'center',
                },
            ]
        }
    },
    computed: {
        userEmail() {
            return this.$store.state.user.userEmail
        },
        codeCompliancesList() {
            return this.$store.state.reports.reports.codeCompliancesList
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
    },
    mounted() {
        this.getCodeCompliancesList()
    },
    methods: {
        getCodeCompliancesList() {
            this.compliancePatternsLoading = true
            this.$store.dispatch('reports/getCodeCompliancesList', {
                paginate: this.paginate(),
                query: this.filterQuery,
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.compliancePatternsLoading = false
                })
        },
        generateCodeCompliancesListReport() {
            this.generateReportLoading = true
            this.$store.dispatch('reports/generateCodeCompliancesListReport', {
                query: this.filterQuery,
                userEmail: this.userEmail
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.generateReportLoading = false
                })
        },
        changeFilter() {
            this.resetPagination()
            this.getCodeCompliancesList()
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getCodeCompliancesList()
            }
            this.clearPaginationPending()
        },
    },
}
</script>
